import apple from '@assets/images/benefits-page/apple.svg';
import addLTVBanner from '@assets/images/benefits-page/banner/addLtv.svg';
import bwDurationBanner from '@assets/images/benefits-page/banner/bw-nights.svg';
import bwTicketsBanner from '@assets/images/benefits-page/banner/bw-tickets.svg';
import cashBanner from '@assets/images/benefits-page/banner/cash-incentive.svg';
import customizedBanner from '@assets/images/benefits-page/banner/customized.svg';
import discountBanner from '@assets/images/benefits-page/banner/discounted.svg';
import dvrmBanner from '@assets/images/benefits-page/banner/dvrm.svg';
import checkBanner from '@assets/images/benefits-page/banner/green-card.svg';
import grpMedicalBanner from '@assets/images/benefits-page/banner/grp-medical.svg';
import marketingBanner from '@assets/images/benefits-page/banner/marketing.svg';
import personalLoanBanner from '@assets/images/benefits-page/banner/personalLoan.svg';
import priorityBanner from '@assets/images/benefits-page/banner/priority.svg';
import tradeBanner from '@assets/images/benefits-page/banner/trade.svg';
import blackback from '@assets/images/benefits-page/black-back.svg';
import addLTV from '@assets/images/benefits-page/card/additional-LTV.svg';
import addLTVActive from '@assets/images/benefits-page/card/additional_LTV-active.svg';
import backgrey from '@assets/images/benefits-page/card/back-grey.svg';
import bwDurationActive from '@assets/images/benefits-page/card/biz-wheel-duration-active.svg';
import bwDuration from '@assets/images/benefits-page/card/biz-wheel-duration.svg';
import bwTicketsActive from '@assets/images/benefits-page/card/biz-wheel-tickets-active.svg';
import bwTickets from '@assets/images/benefits-page/card/biz-wheel-tickets.svg';
import cashActive from '@assets/images/benefits-page/card/cash-incentive-active.svg';
import cash from '@assets/images/benefits-page/card/cash-incentive.svg';
import checkActive from '@assets/images/benefits-page/card/check-active.svg';
import check from '@assets/images/benefits-page/card/check.svg';
import customizedActive from '@assets/images/benefits-page/card/customized-active.svg';
import customized from '@assets/images/benefits-page/card/customized.svg';
import discountActive from '@assets/images/benefits-page/card/discount-active.svg';
import discount from '@assets/images/benefits-page/card/discount.svg';
import dvrmActive from '@assets/images/benefits-page/card/dvrm-active.svg';
import dvrm from '@assets/images/benefits-page/card/dvrm.svg';
import grpMedicalActive from '@assets/images/benefits-page/card/grp-medical-active.svg';
import grpMedical from '@assets/images/benefits-page/card/grp-medical.svg';
import marketingActive from '@assets/images/benefits-page/card/marketing-sp-active.svg';
import marketing from '@assets/images/benefits-page/card/marketing-sp.svg';
import personalLoanActive from '@assets/images/benefits-page/card/personal-loan-active.svg';
import personalLoan from '@assets/images/benefits-page/card/personal-loan.svg';
import priorityActive from '@assets/images/benefits-page/card/priority-active.svg';
import priority from '@assets/images/benefits-page/card/priority.svg';
import tradeActive from '@assets/images/benefits-page/card/trade-active.svg';
import trade from '@assets/images/benefits-page/card/trade.svg';
import document from '@assets/images/benefits-page/document.svg';
import gift from '@assets/images/benefits-page/gift.svg';
import mstars from '@assets/images/benefits-page/mobile-stars.svg';
import playstore from '@assets/images/benefits-page/playstore.svg';
import arrow from '@assets/images/benefits-page/right-arrow.svg';
import stars from '@assets/images/benefits-page/stars.svg';
import back from '@assets/images/black-back.svg';
import benefits from '@assets/images/dashboard/benefits.png';
import reports from '@assets/images/dashboard/reports.png';
import twoWheeler from '@assets/images/dashboard/two-wheeler.png';
import person1 from '@assets/images/landing-page/person1.png';
import arrowDownBlack from '@assets/images/lead-page/arrow-down-black.svg';
import arrowDownGrey from '@assets/images/lead-page/arrow-down-grey.svg';
import arrowLeft from '@assets/images/lead-page/arrow-left.svg';
import arrowUpGrey from '@assets/images/lead-page/arrow-up-grey.svg';
import arrowUpWhite from '@assets/images/lead-page/arrow-up-white.svg';
import crossGrey from '@assets/images/lead-page/cross-grey.svg';
import download from '@assets/images/lead-page/download.svg';
import sort from '@assets/images/lead-page/ep_sort.svg';
import filterBlack from '@assets/images/lead-page/filter-black.svg';
import filterWhite from '@assets/images/lead-page/filter-white.svg';
import next from '@assets/images/lead-page/next-page.svg';
import previous from '@assets/images/lead-page/previous-page.svg';
import logo from '@assets/images/logo.svg';
import poweredBy from '@assets/images/powered-by-razorpay.png';
import barChart from '@assets/images/reports/bar-chart.svg';
import vppLogo from '@assets/images/vpp-logo.jpg';
import backWhite from '@assets/images/white-back.svg';

export const images = {
  logo,
  vppLogo,
  poweredBy,
  back,
  backWhite,
};

export const landingPage = {
  heroSection: {
    person1,
  },
};

export const reportsPage = {
  header: {
    back,
    barChart,
  },
  main: {
    arrowUpGrey,
    arrowDownGrey,
  },
};

export const benefitsPage = {
  header: {
    back,
    stars,
    gift,
    mstars,
    blackback,
    backgrey,
  },
  banner: {
    addLTVBanner,
    bwDurationBanner,
    bwTicketsBanner,
    cashBanner,
    checkBanner,
    customizedBanner,
    discountBanner,
    dvrmBanner,
    grpMedicalBanner,
    marketingBanner,
    personalLoanBanner,
    priorityBanner,
    tradeBanner,
  },
  card: {
    tradeActive,
    priorityActive,
    customizedActive,
    checkActive,
    discountActive,
    bwDuration,
    bwDurationActive,
    bwTicketsActive,
    bwTickets,
    cashActive,
    cash,
    grpMedicalActive,
    grpMedical,
    personalLoanActive,
    personalLoan,
    marketingActive,
    marketing,
    dvrm,
    dvrmActive,
    discount,
    priority,
    trade,
    customized,
    check,
    arrow,
    addLTV,
    addLTVActive,
  },
  data: {
    document,
    apple,
    playstore,
  },
};

export const dashboard = {
  twoWheeler,
  benefits,
  reports,
};

export const lead = {
  leadHeader: {
    arrowLeft,
    download,
    sort,
    filterBlack,
    filterWhite,
    arrowDownGrey,
    arrowUpGrey,
    arrowDownBlack,
    arrowUpWhite,
    crossGrey,
    previous,
    next,
  },
};
